import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m21.53 20.469-4.694-4.694a8.26 8.26 0 1 0-1.06 1.06l4.693 4.695a.751.751 0 0 0 1.06-1.061m-17.78-9.97a6.75 6.75 0 1 1 6.75 6.75 6.757 6.757 0 0 1-6.75-6.75"
	})
});
const Memo = memo(SvgMagnifyingGlass);
export default Memo;
